import {
  useReactTable,
  getCoreRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  getFilteredRowModel,
} from "@tanstack/react-table";
import PropTypes from "prop-types";
import { useState } from "react";
import { toast } from "sonner";
import fotoDefault from "../../img/productoVacio.png";

export default function TableProduct({ data, columns, filtering, setFiltering,channel,deleteProducto,changeStatus }) {
  const [sorting, setSorting] = useState([]);
  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    state: { sorting, globalFilter: filtering },
    onSortingChange: setSorting,
    onGlobalFilterChange: setFiltering,
  });

  const pageIndex = table.getState().pagination.pageIndex; 
  const pageSize = table.getState().pagination.pageSize; 
  const totalRows = data.length; 
  const totalPages = table.getPageCount(); 

  const startItem = pageIndex * pageSize + 1;
  const endItem = Math.min((pageIndex + 1) * pageSize, totalRows);

  return (
    <>
      <div className="table-table-responsive scrollbar mx-n1 px-1">
        <table className="table fs-9 mb-0">
          <thead>
            {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map((header) => (
                  <th
                    className={header.column.columnDef.className}
                    scope="col"
                    data-sort="product"
                    style={{ width: header.column.columnDef.width }}
                    key={header.id}
                    onClick={header.column.getToggleSortingHandler()}
                  >
                    {header.isPlaceholder
                      ? null
                      : header.column.columnDef.header}
                    {header.column.getIsSorted() === "asc"
                      ? "⬆️"
                      : header.column.getIsSorted() === "desc"
                      ? "⬇️"
                      : null}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody className="list" id="products-table-body">
            {table.getRowModel().rows.map((row) => (
              <tr key={row.id} className="position-static">
                <td className="align-middle white-space-nowrap py-2">
                  <a
                    className="d-block border border-translucent rounded-2"
                    href={
                      row.original.foto && row.original.foto.trim() !== ""
                        ? `data:image/jpeg;base64,${row.original.foto}`
                        : fotoDefault
                    }
                    data-gallery="gallery-posts-0"
                  >
                    <img
                      className="rounded-2"
                      src={
                        row.original.foto && row.original.foto.trim() !== ""
                          ? `data:image/jpeg;base64,${row.original.foto}`
                          : fotoDefault
                      }
                      alt="Foto del producto"
                      width="53"
                    />
                  </a>
                </td>
                <td className="product align-middle ps-4">
                  {row.original.nombre.length > 20
                    ? row.original.nombre.substr(0, 20) + "..."
                    : row.original.nombre}
                </td>
                <td className="price align-middle white-space-nowrap text-start fw-bold text-body-tertiary ps-4">
                  S/.{row.original.pventa}
                </td>
                <td className="price align-middle white-space-nowrap text-start fw-bold text-body-tertiary ps-4">
                  S/.{row.original.pcompra}
                </td>
                <td className="category align-middle white-space-nowrap text-body-quaternary fs-9 ps-0 fw-semibold">
                  {row.original.nameCategoria}
                </td>
                <td className="product align-middle ps-0 fw-bold">
                  {
                    (() => {
                      switch (row.original.tipo) {
                        case "P":
                          return "Producto";
                        case "S":
                          return "Servicio";
                        case "Q":
                          return "Paquete";
                        default:
                          return "Desconocido";
                      }
                    })()
                  }
                </td>
                <td className="product align-middle ps-4">
                  {row.original.stock}
                </td>
                <td className={"product align-middle ps-0 text-primary"}>
                  {row.original.estado === "S" ? (
                    <span className="badge text-bg-success rounded-4">
                      <span className="badge-label">Activo</span>
                    </span>
                  ) : (
                    <span className="badge text-bg-danger rounded-4">
                      <span className="badge-label">Inactivo</span>
                    </span>
                  )}
                </td>
                <td className="product align-middle ps-4">
                  <div className="btn-reveal-trigger position-static">
                    <button
                      className="btn btn-sm dropdown-toggle dropdown-caret-none transition-none btn-reveal fs-10"
                      type="button"
                      data-bs-toggle="dropdown"
                      data-boundary="window"
                      aria-haspopup="true"
                      aria-expanded="false"
                      data-bs-reference="parent"
                    >
                      <span className="fas fa-ellipsis-h fs-10"></span>
                    </button>
                    <div className="dropdown-menu dropdown-menu-end py-2">
                      <button className="dropdown-item text-body" onClick={()=> toast.warning("Funcionalidad aun no disponible") }>
                        Kardex
                      </button>
                      <button className="dropdown-item text-body" onClick={()=>{changeStatus(row.original.estado,row.original.idPServicio)}}>
                        {(row.original.estado === "S") ? "Deshabilitar" : "Habilitar"} 
                      </button>
                      <div className="dropdown-divider"></div>
                      <button className="dropdown-item text-info" onClick={()=>{channel(row.original)}}>
                        Editar
                      </button>
                      <button className="dropdown-item text-danger" onClick={() => {deleteProducto(row.original.idPServicio)}}>
                        Eliminar
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="d-flex justify-content-between align-items-center mt-4 mb-3 position-relative">
          <p className="mb-0 fs-9">
            <span className="d-none d-sm-inline-block">
              {startItem} a {endItem}
              <span className="text-body-tertiary"> Elementos de </span>
              {totalRows}
            </span>
          </p>

          <div className="d-flex position-absolute start-50 translate-middle-x">
            <button
              className="page-link btn btn-subtle-secondary me-1 mb-1"
              type="button"
              onClick={() => table.setPageIndex(0)}
              disabled={!table.getCanPreviousPage()}
            >
              <span className="fas fa-angle-double-left"></span>
            </button>
            <button
              className="page-link btn btn-subtle-primary me-1 mb-1"
              type="button"
              onClick={() => table.previousPage()}
              disabled={!table.getCanPreviousPage()}
            >
              <span className="fas fa-chevron-left"></span>
            </button>
            <button
              className="page-link btn btn-subtle-primary me-1 mb-1"
              type="button"
              onClick={() => table.nextPage()}
              disabled={!table.getCanNextPage()}
            >
              <span className="fas fa-chevron-right"></span>
            </button>
            <button
              className="page-link btn btn-subtle-secondary me-1 mb-1"
              type="button"
              onClick={() => table.setPageIndex(table.getPageCount() - 1)}
              disabled={!table.getCanNextPage()}
            >
              <span className="fas fa-angle-double-right"></span>
            </button>
          </div>

          <p className="mb-0 fs-9">
            Pagina {pageIndex + 1} de {totalPages}
          </p>
        </div>
      </div>
    </>
  );
}

TableProduct.propTypes = {
  data: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  setFiltering: PropTypes.func,
  filtering: PropTypes.string,
  channel: PropTypes.func,
  deleteProducto: PropTypes.func,
  changeStatus: PropTypes.func,
};
